import { render, staticRenderFns } from "./GatewayTargetServers.vue?vue&type=template&id=64417bb2&scoped=true"
import script from "./GatewayTargetServers.vue?vue&type=script&lang=js"
export * from "./GatewayTargetServers.vue?vue&type=script&lang=js"
import style0 from "./GatewayTargetServers.vue?vue&type=style&index=0&id=64417bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64417bb2",
  null
  
)

export default component.exports